import { fwcColor } from 'foundations-theming/utils/fwc';
/**
 * Generates the color tokens for the given link use.
 * The tokens are provided for each interactive state.
 * @param variant - The link use value.
 * @returns The color tokens for the given use.
 */
export const getColorTokensForUse = (use, isControl) => {
  switch (use) {
    case 'blue':
    case 'dark':
    case 'light':
      if (isControl) {
        return {
          idle: fwcColor('fwc-link-specialty-text-interactive-alt-default'),
          hover: fwcColor('fwc-link-specialty-text-interactive-alt-hover'),
          active: fwcColor('fwc-link-specialty-text-interactive-alt-pressed'),
          disabled: fwcColor('fwc-link-text-interactive-default-disabled')
        };
      }
      return {
        idle: fwcColor('fwc-link-text-interactive-default'),
        hover: fwcColor('fwc-link-text-interactive-default-hover'),
        active: fwcColor('fwc-link-text-interactive-default-pressed'),
        disabled: fwcColor('fwc-link-text-core-disabled')
      };
    case 'mention':
    case 'on-bright':
      if (isControl) {
        return {
          idle: fwcColor('fwc-link-specialty-text-interactive-alt-default'),
          hover: fwcColor('fwc-link-specialty-text-interactive-alt-hover'),
          active: fwcColor('fwc-link-specialty-text-interactive-alt-pressed'),
          disabled: fwcColor('fwc-link-text-interactive-default-disabled')
        };
      }
      return {
        idle: fwcColor('fwc-link-specialty-text-core-alt-default'),
        hover: fwcColor('fwc-link-text-interactive-default-hover'),
        active: fwcColor('fwc-link-text-interactive-default-pressed'),
        disabled: fwcColor('fwc-link-text-core-disabled')
      };
    case 'danger':
      return {
        idle: fwcColor('fwc-link-text-alert-default'),
        hover: fwcColor('fwc-link-text-alert-hover'),
        active: fwcColor('fwc-link-text-alert-pressed'),
        disabled: fwcColor('fwc-link-text-core-disabled')
      };
    case 'on-dark':
      return {
        idle: fwcColor('fwc-link-specialty-link-on-fill-alt-default'),
        hover: fwcColor('fwc-link-specialty-link-on-fill-alt-hover'),
        active: fwcColor('fwc-link-specialty-link-on-fill-alt-pressed'),
        disabled: fwcColor('fwc-link-specialty-link-on-fill-alt-disabled')
      };
    case 'unstyled':
      return {
        idle: fwcColor('fwc-link-text-core-default'),
        hover: fwcColor('fwc-link-text-core-default'),
        active: fwcColor('fwc-link-text-core-default'),
        disabled: fwcColor('fwc-link-text-core-disabled')
      };
    case 'on-fill':
      return {
        idle: fwcColor('fwc-link-specialty-link-on-fill-default'),
        hover: fwcColor('fwc-link-specialty-link-on-fill-hover'),
        active: fwcColor('fwc-link-specialty-link-on-fill-pressed'),
        disabled: fwcColor('fwc-link-specialty-link-on-fill-disabled')
      };
    default:
      {
        const __exhaustiveCheck = use;
        throw new Error(`Unhandled \`use\` argument: ${use}`);
      }
  }
};